import { ReactComponent as Step1 } from "../../../../img/step1.svg";
import { ReactComponent as Step2 } from "../../../../img/step2.svg";
import { ReactComponent as Step3 } from "../../../../img/step3.svg";

import classes from "./Step.module.css";

const Step = ({ className }) => {
  return (
    <section className={`${className} ${classes.step}`}>
      <div className={classes.headingContainer}>
        <span className={classes.subheading}>HOW IT WORKS</span>
        <h2 className={classes.heading}>三個步驟客製化你的贈品</h2>
      </div>
      <div className={classes.step__container}>
        <div className={`${classes.step__detail}`}>
          <div className={classes.step__title}>
            <hgroup className={classes.step__titleHeading}>
              <h3>第一步</h3>
              <h4>瀏覽我們的產品</h4>
            </hgroup>
            <p>
              瀏覽我們的產品瀏覽我們的產品瀏覽我們的產品瀏覽我們的產品瀏覽我們的產品
            </p>
          </div>
          <figure className={classes.step__img}>
            <Step1 width="100%" className={classes.step1} />
          </figure>
        </div>
        <div className={classes.step__detail}>
          <div className={`${classes.step__title} ${classes.step2__title}`}>
            <hgroup className={classes.step__titleHeading}>
              <h3>第二步</h3>
              <h4>選擇有興趣的產品</h4>
            </hgroup>
            <p>
              選擇你有興趣的產品選擇你有興趣的產品選擇你有興趣的產品選擇你有興趣的產品
            </p>
          </div>
          <figure className={classes.step__img}>
            <Step2 width="100%" />
          </figure>
        </div>
        <div className={classes.step__detail}>
          <div className={classes.step__title}>
            <hgroup className={classes.step__titleHeading}>
              <h3>第三步</h3>
              <h4>與我們諮詢</h4>
            </hgroup>
            <p>
              與我們諮詢與我們諮詢與我們諮詢與我們諮詢與我們諮詢與我們諮詢與我們諮詢與我們諮詢
            </p>
          </div>
          <figure className={classes.step__img}>
            <Step3 width="100%" />
          </figure>
        </div>
      </div>
    </section>
  );
};

export default Step;
